import * as _ from 'lodash'
import { Network } from 'golgi'

import { Atom } from './lib/Atom'
import { Cursor } from './lib/Cursor'
import { Path, PathStep, resolvePathStep, setAtPath, updateAtPath } from './lib/Path'

import * as Model from './types/document'
import DragManager from './view/DragManager';

// export const debugMode = true
export const debugMode = false

export const docAtom = new Atom<Model.Document>(undefined as any)
export const network = new Network()
// network.debug = true

;(window as any).docAtom = docAtom

export const docCell = network.input<Model.Document>(undefined as any)
docAtom.onChange((document: Model.Document) => docCell.set(document))

// stuff for doc cursors

const docGet: (path: Path, safe?: boolean) => any = network.valueFunc('docGet', (path, safe) => {
  if (path.length === 0) {
    return docCell.get()
  } else {
    const initial = docGet(_.initial(path), safe)
    if (!initial) {
      if (!safe) {
        throw new Error("Path " + JSON.stringify(_.initial(path)) + " resolves to undefined; cannot get " + JSON.stringify(_.last(path)))
      } else {
        return undefined
      }
    }
    const key = resolvePathStep(initial, _.last(path) as PathStep)
    return initial[key]
  }
})

export function docCheck(path: Path) {
  return !!docGet(path, true)
}

function getter(path: Path) {
  return docGet(path)
}

function setter(path: Path, value: any) {
  docAtom.update((doc) => setAtPath(doc, path, value))
}

function updater(path: Path, func: (oldValue: any) => any) {
  docAtom.update((doc) => updateAtPath(doc, path, func))
}

// docCursor DOES NOT immediately grab data from the docTree, setting up a
// dependency. It just associates a cursor with the docTree so that you can
// get() it later.

export function docC<T>(path: Path) {
  return new Cursor<T>(path, { getter, setter, updater })
}

// this one grabs data tho :D

// export function docCV<T>(path: Path) {
//   return docC<T>(path).fetch()
// }

export const documentC = docC<Model.Document>([])

export const dragManager = new DragManager()


// WEBPACK FOOTER //
// ./src/globals.ts